module.exports = __webpack_public_path__ + "img/areas_bg_img_min.0e36f5fc.jpg";